<ng-template #tooltipTemplate>
  <p *ngIf="preHtmlTemplate">
    <ng-template *ngTemplateOutlet="preHtmlTemplate"></ng-template>
  </p>

  <ng-container *ngIf="preHtmlTemplate && (customHtmlTemplate || mainHtml || postHtmlTemplate)">
    <br /><br />
  </ng-container>

  <p *ngIf="customHtmlTemplate">
    <ng-template *ngTemplateOutlet="customHtmlTemplate"></ng-template>
  </p>

  <p *ngIf="mainHtml" [innerHTML]="mainHtml"></p>

  <ng-container *ngIf="(customHtmlTemplate || mainHtml) && postHtmlTemplate">
    <br /><br />
  </ng-container>

  <p *ngIf="postHtmlTemplate">
    <ng-template *ngTemplateOutlet="postHtmlTemplate"></ng-template>
  </p>
</ng-template>

<button
  class="help-tooltip-button p-0 border-0 mx-1"
  [title]="title"
  popoverClass="help-popover"
  [attr.aria-pressed]="isPopoverOpened"
  [ngbPopover]="tooltipTemplate"
  [placement]="tooltipPlacement"
  [autoClose]="autoClose"
  (onHidden)="onPopoverHidden()"
  (onShown)="onPopoverShown()"
  type="button"
>
  <my-global-icon [iconName]="iconName"></my-global-icon>
</button>
